export * from "@/ui/components/primitives/ScrollArea/ScrollArea";
export * from "@/ui/components/primitives/ScrollArea/ScrollArea.config";
export * from "@/ui/components/primitives/ScrollArea/ScrollBar";
